import Loadable from 'react-loadable'

import Loader from '~/components/Loading/Cards'

export default Loadable({
  loader: () => import('./components/Router'),
  loading: Loader,
})
